import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { LoadingStates } from 'shared/constants/loadingStates';
import _ from 'lodash';
import { clearForm } from 'plantItemNew/redux/slices/formSlice';
import { generatePlantDesignFormattedApplication } from 'plantDesign/utils/PlantDesignFormatHelper';
import { PLANT_DESIGN_API_BASE_URL } from 'plantDesign/constants/plantDesignConstants';

const initialState = {
  status: undefined,
  errored: false,
  paymentRedirectUrl: undefined,
  paymentReference: undefined,
  paymentDuplicate: undefined,
};

const plantDesignPaymentSlice = createSlice({
  name: 'plantDesignPayment',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initPlantDesignPayment.pending, (state, _) => {
        state.status = LoadingStates.Loading;
        state.paymentReference = undefined;
        state.paymentDuplicate = undefined;
      })
      .addCase(initPlantDesignPayment.rejected, (state, action) => {
        state.status = LoadingStates.Rejected;
        state.errored = action.payload && action.payload.response && action.payload.response.data;
        state.paymentReference = undefined;
        state.paymentDuplicate = undefined;
      })
      .addCase(initPlantDesignPayment.fulfilled, (state, action) => {
        state.status = LoadingStates.Succeeded;
        state.paymentReference = action.payload.paymentReference;
        state.paymentRedirectUrl = action.payload.paymentRedirectUrl;
        state.paymentDuplicate = action.payload.duplicate;
      })
      .addCase(clearForm, () => {
        return initialState;
      });
  },
});

export const initPlantDesignPayment = createAsyncThunk('plantDesignPayment/initPayment', async (arg, { getState }) => {
  const state = getState();

  let copiedData = _.cloneDeep(state);

  let formattedApplication;

  try {
    formattedApplication = generatePlantDesignFormattedApplication(copiedData);
  } catch (error) {
    console.error(error);
    throw error;
  }

  // Do not send the oidc information to the api because it can cause security issue
  delete copiedData.snswOidc;
  delete copiedData.passwordlessOidc;
  delete copiedData.referenceData;
  delete copiedData.plantDesignReferenceData;
  delete copiedData.application.savingApplication;
  delete copiedData.application.creatingApplication;
  delete copiedData.application.receivingApplication;

  copiedData.formattedApplication = formattedApplication;

  const resp = await axios.post(`${PLANT_DESIGN_API_BASE_URL}/initpayment`, copiedData, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return resp.data;
});

export const plantDesignPaymentReducer = plantDesignPaymentSlice.reducer;
